import { Skeleton } from "primereact/skeleton";
import type { PassedBelt } from "sj-ui-toolkit/src/api/user";

export function CompletedCountColumn({
  rowData,
  loading,
}: {
  rowData: PassedBelt;
  loading: boolean;
}) {
  if (loading) return <Skeleton />;

  const count = rowData.lessonsCompleteCount;
  const lessonLabel = count === 1 ? "lesson" : "lessons";

  return (
    <div
      className="flex flex-col body-sm"
      data-testid={`certificate-completed-count-${rowData.id}`}
    >
      <span className="text-muted-aaa">Completed</span>
      <span className="flex">
        <i className="pi-stack text-xs mr-[8px]" />
        {count} {lessonLabel}
      </span>
    </div>
  );
}
